import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import React, { ComponentProps, useContext, useEffect, useState } from "react";
import type { Widget as WidgetType } from "../../../shared/components/Widget/components/Widget";
import { WidgetContext } from "../layout";
import styles from "./WidgetPane.module.scss";
const Widget = dynamic<WidgetPaneProps>(() => import("../../../shared/components/Widget/components/Widget").then(mod => mod.Widget), {
  ssr: false
});
export type PrefilledDistribution = {
  causeAreaId: number;
  share: number;
  organizations: {
    organizationId: number;
    share: number;
  }[];
}[];
export interface WidgetPaneProps extends ComponentProps<typeof WidgetType> {
  darkMode?: boolean;
  prefilled: PrefilledDistribution | null;
  prefilledSum: number | null;
}
export const WidgetPane: React.FC<WidgetPaneProps> = t0 => {
  const $ = _c(17);
  let darkMode;
  let widgetProps;
  if ($[0] !== t0) {
    ({
      darkMode,
      ...widgetProps
    } = t0);
    $[0] = t0;
    $[1] = darkMode;
    $[2] = widgetProps;
  } else {
    darkMode = $[1];
    widgetProps = $[2];
  }
  const [widgetContext] = useContext(WidgetContext);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      transition: "none"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [paneStyle, setPaneStyle] = useState(t1);
  const [paneSlidIn, setPaneSlidIn] = useState(false);
  let t2;
  let t3;
  if ($[4] !== widgetContext.open) {
    t2 = () => {
      if (widgetContext.open) {
        const timeoutId = setTimeout(() => {
          setPaneStyle({
            display: "block"
          });
          setPaneSlidIn(true);
        }, 20);
        return () => clearTimeout(timeoutId);
      }
      const timeoutId_0 = setTimeout(() => {
        setPaneStyle({
          display: "none"
        });
        setPaneSlidIn(false);
      }, 200);
      return () => clearTimeout(timeoutId_0);
    };
    t3 = [widgetContext.open];
    $[4] = widgetContext.open;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== paneStyle || $[8] !== widgetContext.open) {
    t4 = widgetContext.open ? {
      display: "block"
    } : paneStyle;
    $[7] = paneStyle;
    $[8] = widgetContext.open;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const style = t4;
  const widgetOpenClass = widgetContext.open && paneSlidIn ? styles.widgetPaneOpen : "";
  const useDarkmode = darkMode || widgetProps.data.result.color_scheme === "light";
  const t5 = `${styles.widgetPane} ${widgetOpenClass} ${useDarkmode ? styles.dark : ""}`;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.widgetPaneHeader} />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== widgetProps) {
    t7 = <div className={styles.widgetPaneContent}><Widget {...widgetProps} /></div>;
    $[11] = widgetProps;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== style || $[14] !== t5 || $[15] !== t7) {
    t8 = <aside data-cy="widget-pane" className={t5} style={style}>{t6}{t7}</aside>;
    $[13] = style;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};